import { render, staticRenderFns } from "./Upload_save.vue?vue&type=template&id=10c64313&"
import script from "./Upload_save.vue?vue&type=script&lang=js&"
export * from "./Upload_save.vue?vue&type=script&lang=js&"
import style0 from "./Upload_save.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports